import React from 'react';
import Scheduled from '../../components/AdminNext/Scheduled';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Scheduled — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Scheduled />
      </HeadLessLayout>
    )
  };
}

export default action;
